import Vue from "vue";
import {
    Tab,Tabs,List,Swipe, SwipeItem
} from 'vant';
// 将这些组件全局注册
const components = [
    Tab,Tabs,List,Swipe, SwipeItem
];
components.forEach(component => {
  Vue.use(component);
});


// WEBPACK FOOTER //
// ./src/util/vant.js